import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function HowItWorks() {
  const steps = [{
    num: '1',
    title: 'Purchase & Download',
    description: 'You get the 32-page PDF guide instantly.'
  }, {
    num: '2',
    title: 'Print or Email',
    description: 'We recommend printing it out so they have a physical book to hold while practicing.'
  }, {
    num: '3',
    title: 'Enjoy the Silence',
    description: 'Watch them join the family chat and save photos on their own.'
  }];
  return <section className="bg-white py-24 px-6" data-id="element-99">
      <div className="max-w-5xl mx-auto" data-id="element-100">
        <FadeIn data-id="element-101">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-102">
            How It Works
          </h2>
        </FadeIn>

        <div className="relative" data-id="element-103">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-10 left-[15%] right-[15%] h-0.5 bg-warmGray -z-10" data-id="element-104"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8" data-id="element-105">
            {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} className="flex flex-col items-center text-center" data-id="element-106">
                <div className="w-20 h-20 rounded-full bg-amber text-charcoal flex items-center justify-center text-3xl font-bold font-heading mb-6 shadow-warm" data-id="element-107">
                  {step.num}
                </div>
                <h3 className="text-xl font-bold mb-3" data-id="element-108">{step.title}</h3>
                <p className="text-charcoal/80 leading-relaxed max-w-xs" data-id="element-109">
                  {step.description}
                </p>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}